/**
 * COLOR SWATCH PREVIEW (product cards — modèle "produit-couleur" fmsync)
 * --------------------------------------------------------------------------
 * Survol / clic d'une pastille = aperçu / verrouillage du coloris sur la carte
 * (image principale + 2e visuel), sans navigation. Le clic repointe aussi les
 * liens de la carte vers la fiche du coloris.
 *
 * Gère les MÉDIAS VIDÉO : si la média (principale ou secondaire) du coloris
 * courant est une vidéo, on la masque et on affiche une <img> du visuel du
 * coloris sélectionné (sinon la vidéo du 1er coloris resterait). Détection du
 * produit courant -> on restaure les médias d'origine. Fonctionne desktop
 * (survol) et mobile (slides du swipe), via la même mécanique d'override.
 */
(function () {
  if (window.__colorSwatchPreviewInit) return;
  window.__colorSwatchPreviewInit = true;

  var SWATCH = '[data-color-swatch-link]';

  // Taille d'affichage des images de carte (pour que srcset choisisse une image
  // adaptée — petite sur mobile). On reprend le `sizes` de l'image d'origine si
  // dispo, sinon une valeur par défaut alignée sur la grille (2 col mobile / 4 desktop).
  function swatchSizes(card) {
    var pimg = card.querySelector('img.product-card__image--primary');
    return (pimg && pimg.getAttribute('sizes')) || '(max-width: 699px) 50vw, 25vw';
  }

  function handleFromUrl(url) {
    if (!url) return null;
    var m = url.split('?')[0].match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  // 1er élément (primary|secondary) qui n'est PAS notre img d'override
  function origMediaEl(card, role) {
    var els = card.querySelectorAll('.product-card__image--' + role);
    var ov = card['__ov_' + role];
    for (var i = 0; i < els.length; i++) {
      if (els[i] !== ov) return els[i];
    }
    return null;
  }

  function ensureBaseline(card) {
    if (card.__swatchBaseReady) return;
    card.__swatchBaseReady = true;
    ['primary', 'secondary'].forEach(function (role) {
      var el = origMediaEl(card, role);
      card['__orig_' + role] = el;
      // pour le cas <img> (swap en place), on mémorise la source d'origine
      // afin de pouvoir la restaurer au retour sur le coloris courant
      card['__base_' + role] = (el && el.tagName === 'IMG')
        ? { src: el.getAttribute('src'), srcset: el.getAttribute('srcset') }
        : null;
    });
  }

  // Change la source d'une <img> SANS flash : on décode d'abord la nouvelle
  // image (sur une image temporaire), puis on l'applique une fois prête.
  function applyImgSrc(img, src, srcset) {
    if (!img || !src) return;
    if (img.getAttribute('src') === src) { // déjà affichée -> rien à faire (évite le double-swap)
      img.style.removeProperty('display');
      img.__pendingSrc = src;
      return;
    }
    img.__pendingSrc = src;
    var pre = new Image();
    var sizes = img.getAttribute('sizes');
    if (sizes) pre.sizes = sizes;
    if (srcset) pre.srcset = srcset;
    pre.src = src;
    var apply = function () {
      if (img.__pendingSrc !== src) return; // une autre couleur a été demandée entre-temps
      if (srcset) img.setAttribute('srcset', srcset);
      else img.removeAttribute('srcset');
      img.setAttribute('src', src);
      img.style.removeProperty('display');
    };
    if (pre.decode) pre.decode().then(apply).catch(apply);
    else apply();
  }

  // Affiche `src` pour le rôle donné. Si l'élément d'origine est une <img>, on
  // swappe en place ; si c'est une vidéo, on la masque et on affiche une <img>
  // d'override (créée une fois, réutilisée).
  function setMedia(card, role, src, srcset) {
    var orig = card['__orig_' + role];
    if (!orig) return;

    if (!src) {
      // pas de visuel pour ce coloris -> on masque (évite un mauvais média)
      orig.style.display = 'none';
      if (card['__ov_' + role]) card['__ov_' + role].style.display = 'none';
      return;
    }

    if (orig.tagName === 'IMG') {
      applyImgSrc(orig, src, srcset); // swap en place, sans flash
      return;
    }

    // l'original est une vidéo -> on affiche une <img> d'override à sa place.
    // La vidéo n'a pas les classes de format des images (aspect-*, object-cover) :
    // on mesure le cadre AVANT de la masquer pour que l'image le remplisse à
    // l'identique (sinon image en « contain », plus petite que le cadre).
    if (role === 'primary' && !card.__ovFrameRatio) {
      var frame = orig.closest('.product-card__media') || orig;
      var rect = frame.getBoundingClientRect();
      if (rect.width && rect.height) card.__ovFrameRatio = rect.width + ' / ' + rect.height;
    }
    var ov = card['__ov_' + role];
    if (!ov) {
      ov = document.createElement('img');
      // on reprend les classes de dimensionnement de l'original, sans hover-video
      ov.className = (orig.className || ('product-card__image product-card__image--' + role))
        .replace(/\bhover-video\b/g, '')
        .trim();
      ov.setAttribute('sizes', swatchSizes(card)); // image adaptée (rapide sur mobile)
      ov.setAttribute('loading', 'lazy');
      ov.style.objectFit = 'cover';
      ov.style.objectPosition = 'center';
      orig.parentNode.insertBefore(ov, orig.nextSibling);
      card['__ov_' + role] = ov;
    }
    if (role === 'primary') {
      ov.style.width = '100%';
      ov.style.height = 'auto';
      if (card.__ovFrameRatio) ov.style.aspectRatio = card.__ovFrameRatio;
    }
    if (srcset) ov.setAttribute('srcset', srcset);
    else ov.removeAttribute('srcset');
    ov.setAttribute('src', src);
    ov.style.removeProperty('display');
    orig.style.display = 'none';
  }

  function restoreMedia(card, role) {
    var orig = card['__orig_' + role];
    if (orig) {
      orig.style.removeProperty('display');
      // cas <img> : on remet la source d'origine (qu'on avait swappée en place)
      var base = card['__base_' + role];
      if (base && base.src && orig.tagName === 'IMG') {
        applyImgSrc(orig, base.src, base.srcset); // restaure sans flash
      }
    }
    if (card['__ov_' + role]) card['__ov_' + role].style.display = 'none';
  }

  // d = données coloris {primary, secondary} ou null (= produit courant)
  function applyState(card, d) {
    if (!d) {
      restoreMedia(card, 'primary');
      restoreMedia(card, 'secondary');
      return;
    }
    setMedia(card, 'primary', d.primary.src, d.primary.srcset);
    // si le coloris n'a pas de 2e image -> repli sur son image principale
    var secSrc = d.secondary.src || d.primary.src;
    var secSrcset = d.secondary.src ? d.secondary.srcset : d.primary.srcset;
    setMedia(card, 'secondary', secSrc, secSrcset);
  }

  function restore(card) {
    applyState(card, card.__swatchLocked || null);
  }

  function dataOf(link) {
    return {
      primary: { src: link.getAttribute('data-swatch-image'), srcset: link.getAttribute('data-swatch-srcset') },
      secondary: { src: link.getAttribute('data-swatch-secondary-image'), srcset: link.getAttribute('data-swatch-secondary-srcset') }
    };
  }

  // null si la pastille correspond au produit courant (-> on restaure l'original)
  function stateForLink(card, link) {
    var handle = handleFromUrl(link.getAttribute('href') || link.getAttribute('data-product-url'));
    if (!handle || handle === card.getAttribute('handle')) return null;
    return dataOf(link);
  }

  // ---------------------------------------------------------------------------
  // IMAGES 3+ (diapositives --extra : swipe mobile + flèches desktop).
  // Le swatch ne fournit que 2 visuels ; au verrouillage d'un autre coloris on
  // masque les extras d'origine et on les remplace par les images 3+ du coloris
  // (products/{handle}.js). Retour au produit courant = extras d'origine.
  // ---------------------------------------------------------------------------
  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function cdnWidth(src, w) {
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function syncExtras(card, handle) {
    var swipe = card.querySelector('.product-card__media--swipe');
    var inner = swipe && swipe.querySelector('.product-card__media-inner');
    if (!inner) return;

    var token = card.__extraToken = (card.__extraToken || 0) + 1;
    inner.querySelectorAll('[data-swatch-extra]').forEach(function (n) { n.remove(); });
    var originals = inner.querySelectorAll('.product-card__media-slide--extra');
    originals.forEach(function (n) { n.hidden = !!handle; });

    if (!handle) return;
    var max = parseInt(swipe.getAttribute('data-swipe-max'), 10) || 5;
    if (max <= 2) return;

    var model = (originals[0] && originals[0].querySelector('img')) || card.querySelector('img.product-card__image--primary');
    var className = model
      ? model.className.replace('product-card__image--primary', 'product-card__image--extra')
      : 'product-card__image product-card__image--extra size-full object-cover';
    var sizes = swatchSizes(card);

    fetch(shopRoot() + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        if (!product || card.__extraToken !== token) return;
        (product.media || []).slice(2)
          .filter(function (m) { return m.media_type === 'image' && m.src; })
          .slice(0, max - 2)
          .forEach(function (m) {
            var slide = document.createElement('div');
            slide.className = 'product-card__media-slide product-card__media-slide--extra';
            slide.setAttribute('data-swatch-extra', '');
            var img = document.createElement('img');
            img.className = className;
            img.alt = m.alt || '';
            img.draggable = false;
            img.sizes = sizes;
            img.srcset = [300, 400, 600, 800, 1000].map(function (w) { return cdnWidth(m.src, w) + ' ' + w + 'w'; }).join(', ');
            img.src = cdnWidth(m.src, 600);
            slide.appendChild(img);
            inner.appendChild(slide);
          });
      })
      .catch(function () {});
  }

  // Liens de la carte (image, titre…) + achat rapide → URL du coloris affiché.
  // L'URL d'origine est mémorisée pour pouvoir y revenir.
  function setCardUrl(card, url) {
    if (card.__baseUrl === undefined) {
      var first = null;
      card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (!first && !a.matches(SWATCH)) first = a;
      });
      card.__baseUrl = first ? first.getAttribute('href') : null;
    }
    url = url || card.__baseUrl;
    if (!url) return;
    card.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.matches(SWATCH)) return;
      a.setAttribute('href', url);
    });
    var qb = card.querySelector('quick-buy-modal');
    if (qb) qb.setAttribute('product-url', url);
  }

  function linkUrl(link) {
    return link.getAttribute('href') || link.getAttribute('data-product-url');
  }

  // Cercle de sélection
  function ensureActiveBaseline(card) {
    if (card.__lockedActiveItem === undefined) {
      card.__lockedActiveItem = card.querySelector('.color-variant-item.active') || null;
    }
  }
  function setActive(card, item) {
    card.querySelectorAll('.color-variant-item').forEach(function (it) { it.classList.remove('active'); });
    if (item) item.classList.add('active');
  }

  // Retour au coloris cliqué quand on QUITTE LA CARTE (l'aperçu persiste tant
  // qu'on est sur la carte)
  function wireLeave(card) {
    if (card.__swatchLeaveWired) return;
    card.__swatchLeaveWired = true;
    card.addEventListener('pointerleave', function () {
      restore(card);
      setActive(card, card.__lockedActiveItem);
      setCardUrl(card, card.__lockedUrl || null);
    });
  }

  // SURVOL : aperçu temporaire (média + cercle)
  document.addEventListener('pointerover', function (e) {
    var link = e.target.closest && e.target.closest(SWATCH);
    if (!link) return;
    var card = link.closest('product-card');
    if (!card) return;
    ensureBaseline(card);
    ensureActiveBaseline(card);
    wireLeave(card);
    applyState(card, stateForLink(card, link));
    setActive(card, link.closest('.color-variant-item'));
    // le clic sur l'image doit mener au coloris affiché, pas au coloris d'origine
    setCardUrl(card, linkUrl(link));
  });

  // CLIC / TAP : verrouille + repointe les liens, sans naviguer
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest(SWATCH);
    if (!link) return;
    var card = link.closest('product-card');
    if (!card) return;

    e.preventDefault();
    ensureBaseline(card);

    var d = stateForLink(card, link);
    card.__swatchLocked = d; // null = produit courant
    applyState(card, d);

    // mobile : images 3+ du swipe alignées sur le coloris verrouillé
    syncExtras(card, d ? handleFromUrl(link.getAttribute('href') || link.getAttribute('data-product-url')) : null);

    // mobile : si on avait swipé vers la 2e image, on revient au 1er slide
    var swipe = card.querySelector('.product-card__media--swipe');
    if (swipe && typeof swipe.resetSwipe === 'function') swipe.resetSwipe();

    var url = linkUrl(link);
    if (url) {
      setCardUrl(card, url);
      card.__lockedUrl = d ? url : null; // null = coloris d'origine
    }

    ensureActiveBaseline(card);
    var item = link.closest('.color-variant-item');
    card.__lockedActiveItem = item || null;
    setActive(card, item);
  });

  // ---------------------------------------------------------------------------
  // PRÉCHARGEMENT : quand une carte approche du viewport, on précharge les
  // images des coloris-frères (jusqu'à 4) à la taille adaptée -> au tap/survol,
  // l'image est déjà en cache, le changement est quasi instantané.
  // ---------------------------------------------------------------------------
  function preloadCard(card) {
    if (card.__swatchPreloaded) return;
    card.__swatchPreloaded = true;
    var sizes = swatchSizes(card);
    var links = card.querySelectorAll(SWATCH);
    var count = 0;
    for (var i = 0; i < links.length && count < 4; i++) {
      var link = links[i];
      var handle = handleFromUrl(link.getAttribute('href') || link.getAttribute('data-product-url'));
      if (!handle || handle === card.getAttribute('handle')) continue; // image courante déjà chargée
      var srcset = link.getAttribute('data-swatch-srcset');
      var src = link.getAttribute('data-swatch-image');
      if (!srcset && !src) continue;
      var im = new Image();
      if (sizes) im.sizes = sizes;
      if (srcset) im.srcset = srcset;
      if (src) im.src = src;
      count++;
    }
  }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { preloadCard(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '200px 0px' });

    var observeCards = function () {
      document.querySelectorAll('product-card').forEach(function (c) { io.observe(c); });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeCards);
    } else {
      observeCards();
    }

    // cartes ajoutées dynamiquement (filtres / pagination)
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('product-card')) io.observe(n);
          else if (n.querySelectorAll) n.querySelectorAll('product-card').forEach(function (c) { io.observe(c); });
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
